import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError, MASCOT } from "@/lib/api";
import { Logo } from "@/components/Navbar";
import { AuthShell, AuthField } from "@/components/AuthShell";

export default function CompleteSignup() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ name: "", password: "", confirm: "" });
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;
    api.get(`/auth/signup-info/${token}`)
      .then(({ data }) => {
        setEmail(data.email);
        setForm((f) => ({ ...f, name: data.name || "" }));
      })
      .catch(() => {});
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error("As senhas não conferem");
    if (form.password.length < 6) return toast.error("A senha deve ter no mínimo 6 caracteres");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/complete-signup", {
        signup_token: token, name: form.name, password: form.password,
      });
      login(data.user);
      toast.success(`Bem-vinda, ${data.user.name}! Vamos criar seu primeiro anúncio.`);
      navigate("/painel");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <AuthShell title="Link inválido" subtitle="Este link de cadastro não é válido. Escolha um plano para começar." mascot={MASCOT.tilt}>
        <button onClick={() => navigate("/")} className="btn-orange w-full py-3.5 rounded-full font-semibold">Ver planos</button>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Crie sua senha" subtitle="Pagamento confirmado! Só falta criar seu acesso." mascot={MASCOT.happy}>
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        {email && (
          <div className="rounded-xl bg-[#fdf8f3] border border-[#e8d8c8] px-4 py-2.5 text-sm text-[#5c4634]" data-testid="signup-email">
            E-mail da conta: <b className="text-[#9c5f27]">{email}</b>
          </div>
        )}
        <AuthField label="Seu nome" testid="signup-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Maria Vendedora" required />
        <AuthField label="Senha" testid="signup-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Mínimo 6 caracteres" required />
        <AuthField label="Confirmar senha" testid="signup-confirm" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} placeholder="Repita a senha" required />
        <button type="submit" disabled={loading} className="btn-orange w-full py-3.5 rounded-full font-semibold disabled:opacity-60" data-testid="signup-submit">
          {loading ? "Criando conta..." : "Criar conta e entrar"}
        </button>
      </form>
    </AuthShell>
  );
}
